var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.step == 5)?_c('div',{staticClass:"component",attrs:{"id":"dogee"}},[_vm._m(0),_c('div',{staticClass:"dogee"},[_c('img',{attrs:{"src":_vm.dog,"alt":""}})])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dogee__text"},[_vm._v(" Всегда рады "),_c('br'),_vm._v(" встрече с вами! ")])
}]

export { render, staticRenderFns }